import React from 'react';

const ChecklistIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="44"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#1a5d3a"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M9 11l3 3L22 4" />
    <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" />
  </svg>
);

const ApplicationPreview = () => (
  <div
    className="bg-white rounded-xl p-8 shadow-sm border border-gray-100 flex flex-col items-center justify-center text-center"
    style={{ minHeight: '220px' }}
    data-testid="application-preview-panel"
  >
    <div
      className="w-16 h-16 rounded-2xl flex items-center justify-center mb-5"
      style={{ backgroundColor: '#f5f0e8' }}
    >
      <ChecklistIcon />
    </div>
    <h2 className="text-base font-semibold text-gray-900 mb-2">Application Tracker</h2>
    <p className="text-sm text-gray-500 max-w-xs leading-relaxed">
      Track your college applications in one place &mdash; coming soon.
    </p>
  </div>
);

export default ApplicationPreview;
